module.exports = __webpack_public_path__ + "static/media/pinpoint.59e445d3.gif";